import React, {useState, useMemo, useEffect} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import "../../assets/styles/barhide.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import NfsmSidebar from "../Common/NfsmSidebar";
import nfsm from "../../assets/images/slider-4.jpg";
import axios from "axios";
import MaterialReactTable from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { useNavigate, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
function FarmerandCropwiseReport() {

  const [farmerData, setFarmerData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const { state } = useLocation();

  const [csvData, setCSVData] = useState([])
  const [csvFileName, setCSVFileName] = useState("Farmer");

  const columns = useMemo(() => [
    {
      header: "S.No",
      Cell: (cell) => Number(cell.row.id) + 1,
    },
    {
      accessorKey: "cfldid",
      header: "CFLD ID",
    },
    {
      accessorKey: "seasonName",
      header: "Season Name",
    },
    {
      accessorKey: "stateName",
      header: "State",
    },
    {
      accessorKey: "districtName",
      header: "District",
    },
    {
      accessorKey: "blockName",
      header: "Block",
    },
    {
      accessorKey: "villageName",
      header: "Village",
    },
    {
      accessorKey: "cropGroupName",
      header: "Crop Group",
    },

    {
      accessorKey: "cropName",
      header: "Crop Name",
    },
    {
      accessorKey: "varietalCharName", 
      header: "Crop Variety",
    },
  {
    accessor: '',
    header: 'Beneficiary Name',
    Cell: cell => <><i className="btn text-success" type="button" onClick={(e) => viewData(cell.row.original)}><span>{cell.row.original.beneficiaryName} </span> </i></>
   },
    {
      accessorKey: "plotArea",
      header: "Plot Area",
    },
    {
      accessorKey: "outcomeUploadingStatus",
      header: "Outcome Uploading Status",
    },
     {
      accessorKey: "demonstrationYield",
      header: "Demonstration Yield",
    }, 
     {
      accessorKey: "averageYieldofVillage",
      header: "Average Yield of Village",
    },
  
  
//   {
//     accessor: '',
//     header: "Farmers haven’t Uploaded Outcomes",
//     Cell: cell =>   <i className="btn text-primary" type="button" onClick={() => navigate("/farmerandcropwisereport", { state: { cropSurveyCode: cell.row.original, status: 0 } })}><span>{cell.row.original.farmerNotUploadedOutcomes}</span></i>
       
// },

  ]);

  // Below Code is use to download table data as CSV
  const handleExportData = () => {
    const csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: Object.keys(farmerData[0]),
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(farmerData);
  };

  useEffect(() => {
    setIsFetching(true);
    const fetchFarmer = async () => {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/NFSMMISDashbard/GetCFLDDetailsbyID`, {
          "cfldid": state.cropSurveyCode.cropDemonstrationCode,
          "completeStatus": state.status,
          "villageCode" : String(state.cropSurveyCode.villageCode),
          "case" : 3

        }
      );
     
      if(result.data.data) {
        setFarmerData(result.data.data);
        setIsFetching(false);
      }else {
        setFarmerData([]);
        setIsFetching(false);
      }


    };
    fetchFarmer();
  }, []);



  function viewData(data) {
console.log("value ##", data)
    const fetchPopupDetails = async () => {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/NFSMMISDashbard/GetFarmerDetailsbyID`, {
          "farmerID": data.beneficiaryCode,
          "outcomeStatus": data.outcomeUploadingStatus === "Incompleted" ? 0 : 1
  
        }
      );
     
      if(result.data.data) {
      console.log("data", result.data.data)
      var x = document.createElement("a")
      x.id = "mpopupLink";
      var mpopup = document.getElementById('mpopupBox');
      mpopup.style.display = "block";
      let value = result.data.data[0]
      console.log("value", value)
  
      document.getElementById("modal-content2").innerHTML = `<div class="row">  <div class="col-md-9"><div class="row"><div class="col-md-4"> <h6> Date of Creation: </h6> <p>${value.createdOn.split("T")[0] }</p> </div> <div class="col-md-4"> <h6> Farmer ID: </h6> <p>${value.beneficiaryCodeM }</p> </div> <div class="col-md-4"> <h6> Farmer Name: </h6> <p>${ value.beneficiaryName }</p> </div> <div class="col-md-4"> <h6> State: </h6> <p>${value.stateName }</p> </div> <div class="col-md-4"> <h6> District: </h6> <p>${value.districtName }</p> </div> <div class="col-md-4"> <h6> Block: </h6> <p>${ value.blockName }</p> </div> <div class="col-md-4"> <h6> Village: </h6> <p>${ value.villageName }</p> </div> <div class="col-md-4"> <h6> Khasra No.: </h6> ${value.khasraNo}</p> </div> <div class="col-md-4"> <h6> Plot Area: </h6> <p>${value.totalArea }</p> </div> <div class="col-md-4"> <h6> Crop Name: </h6> <p>${ value.cropName }</p> </div> <div class="col-md-4"> <h6> Crop Variety: </h6> <p>${value.cropVarietyName }</p> </div> <div class="col-md-4"> <h6> Outcome Upload Status: </h6> <p>${ value.outcomeStatus}</p> </div></div> </div>  <div class="col-md-3"> <div class="cropimages"> <div class="tablenewresponsive">  <a href=  ${value.photo === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : `https://nfsm.gov.in/nfsmapi1/${value.photo}`} download><img src=  ${value.photo === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : `https://nfsm.gov.in/nfsmapi1/${value.photo}`} alt="image" /> Download Pic</a>  </div> </div> </div></div> `

     

      // https://nfsm.gov.in/nfsmapi1/${value.photo}
 
      const csvDataLocal = [
        ["Date of Creation", "Farmer ID", "Farmer Name", "State", "District", "Block", "Village", "Khasra No", "Plot Area", "Crop Name", "Crop Variety", "Outcome Upload Status", ],
       [    value.createdOn.split("T")[0],  value.beneficiaryCodeM,  value.beneficiaryName,  value.stateName, value.districtName, value.blockName,  value.villageName ,   value.khasraNo ,  value.totalArea,  value.cropName,   value.cropVarietyName, value.outcomeStatus]
      ];
  
      setCSVData(csvDataLocal)
      setCSVFileName(value.beneficiaryCodeM)

      }else {
       
      }
  
  
    };

       fetchPopupDetails()
   

      }
    
    function removed() {
      var mpopup = document.getElementById('mpopupBox');
      mpopup.style.display = "none";
    
    }


  return (
    <>
      <NfsmSidebar />
      <div className="page-wrapper chiller-theme toggled">
     
        <main id="main" className="main ">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h1>NFSM Reports</h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Admin</li>
                <li className="breadcrumb-item active">{state.status === 1 ? "Farmers Uploaded Outcomes " : "Farmers haven’t Uploaded Outcomes" }</li>
              </ol>
            </nav>
            <Link className="btn btn-success" to="/NFSMFarmersOutcomesUploadedReport">
              BACK
            </Link>
          </div>
      <div className="row">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={farmerData}
                  enableColumnOrdering
                  enablePagination={true}
                  state={{ isLoading: isFetching ? true : false }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export in CSV
                      </Button>
                    </Box>
                  )}
                />
              </div>
            </div>
          </div>
          </main>
          </div>
          <div id="mpopupBox" className="modal">

<div className="modal-content" >
<div className="modal-header">
     <h2>CFLD WISE REPORT CARD   <CSVLink className="downloadbtn" filename={csvFileName}data={csvData}>
      <FontAwesomeIcon icon={faDownload}/>  EXPORT TO CSV
      </CSVLink></h2>
    <button type="button" className="btn-close" onClick={removed}>X</button>
    </div>
    <div className="madal-body p-4" id="modal-content2" >
   


    </div>
    <div className="modal-footer">
       
    </div>
</div>
                 
</div>
    </>
  );
}

export default FarmerandCropwiseReport;
